module.exports = __webpack_public_path__ + "static/mstile-150x150-61978cba3dfd261cfe0f47ef4fc9a6b2.png";